import React from 'react';
import './App.css';
import RandomAsianDudeExperience from './components/RandomAsianDudeExperience';

function App() {
  return (
    <div className="App">
      <RandomAsianDudeExperience />
    </div>
  );
}

export default App;
